import ReactDOM from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import ProductImage from '@assets/png/product.png';

import { IProduct } from '@models/Product.model';
import {
  Buttons,
  CloseButton,
  ColumnDiv,
  Container,
  Description,
  Empty,
  EmptyDescription,
  Field,
  Header,
  HeaderBar,
  Image,
  Label,
  LinkText,
  MatchButton,
  Overlay,
  RowDiv,
} from './ProductDetail.styles';

interface IAddFieldContent {
  open: boolean;
  onClose: () => void;
  product: IProduct | undefined;
  onSelectProduct: () => void;
}

const ProductDetail = ({
  open,
  onClose,
  onSelectProduct,
  product,
}: IAddFieldContent) => {
  const portalDiv = document.getElementById('portal');

  if (!product) return <div />;

  return open && portalDiv
    ? ReactDOM.createPortal(
        <Overlay>
          <Container>
            <HeaderBar>
              <Header>Product Details</Header>
              <CloseButton onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </HeaderBar>
            <RowDiv>
              <Image
                src={product.imageUrl || ProductImage}
                brokenSrc={ProductImage}
              />

              <ColumnDiv>
                <div style={{ marginBottom: 16, marginRight: 16 }}>
                  <Label>Model #</Label>
                  {product.model ? (
                    <Field>{product.model}</Field>
                  ) : (
                    <Empty>Empty</Empty>
                  )}
                </div>
                <div style={{ marginRight: 16 }}>
                  <Label>Product Name</Label>
                  {product.name ? (
                    <Field>{product.name}</Field>
                  ) : (
                    <Empty>Empty</Empty>
                  )}
                </div>
              </ColumnDiv>
              <ColumnDiv>
                <div style={{ marginBottom: 16, marginRight: 16 }}>
                  <Label>Manufacturer</Label>
                  {product.manufacturer?.name ? (
                    <Field>{product.manufacturer.name}</Field>
                  ) : (
                    <Empty>Empty</Empty>
                  )}
                </div>
                <div style={{ marginRight: 16 }}>
                  <Label>Product Page</Label>
                  {product.productPage ? (
                    <LinkText
                      onClick={() => {
                        window.open(product.productPage as string, '_blank');
                      }}
                    >
                      {`${product.model} Page`}
                    </LinkText>
                  ) : (
                    <Empty>Empty</Empty>
                  )}
                </div>
              </ColumnDiv>
            </RowDiv>
            <Label>Product Description</Label>
            {product.description ? (
              <Description
                className="bscroll"
                dangerouslySetInnerHTML={{ __html: product.description }}
              />
            ) : (
              <EmptyDescription>Empty</EmptyDescription>
            )}

            <Buttons>
              <MatchButton onClick={onSelectProduct}>
                Select this Product
              </MatchButton>
            </Buttons>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};

export { ProductDetail };
